import { render, staticRenderFns } from "./login_block.vue?vue&type=template&id=3b976dce&"
import script from "./login_block.vue?vue&type=script&lang=js&"
export * from "./login_block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports